import React from "react";
import {useTable, useSortBy} from "react-table";
import {useSelector} from "react-redux";
import ReactPaginate from "react-paginate";
import {DefaultArrow, DownArrow, UpArrow} from "../../../Resident/sortArrows";
import moment from "moment/moment";

const FormSubmissionsTab = () => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });

  const [formSubmissions, setFormSubmissions] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);

  const fetchFacilities = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/form_submissions.json?${$.param(createRansackQuery())}`,
      success: (response) => {
        setFormSubmissions(response.form_submissions);
        setTotalPages(response.total_pages);
        setCurrentPage(response.current_page);
      }
    })
  }

  const createRansackQuery = () => {
    return {
      page: currentPage
    }
  }

  React.useEffect(() => {
    fetchFacilities();
  }, [currentPage]);

  const columns = React.useMemo(() => [
    {
      Header: "Facility Name",
      id: "facility_name",
      disableSortBy: true,
      accessor: (row) => row.facility_name,
      Cell: ({cell: {row: {original}}}) => (
        <a href={`/organizations/${state.organizationName}/facilities/${original.submissionable_id}`} target="_blank">{original.facility_name}</a>
      )
    },
    {
      Header: "Submission Name",
      id: "submission_name",
      disableSortBy: true,
      accessor: (row) => row.submission_name,
      Cell: ({cell: {row: {original}}}) => (
        <a href={`/organizations/${state.organizationName}/forms/${original.form_id}/submissions/${original.uuid}`} target="_blank">{original.submission_name}</a>
      )
    },
    {
      Header: "Date of Submission",
      id: "asset_updated_at",
      accessor: (row) => row.asset_updated_at,
      disableSortBy: true,
      Cell: ({cell: {row: {original}}}) => (
        <span>{moment(original.asset_updated_at).format("MM/DD/YYYY")}</span>
      )
    },
  ], [formSubmissions])

  const {getTableProps, headerGroups, rows, prepareRow} = useTable(
    {
      columns,
      data: formSubmissions,
      initialState: {},
      manualSorting: true
    },
    useSortBy
  );

  return (
    <>
      <table {...getTableProps()} className="table table-responsive">
        <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                {
                  !column.disableSortBy && (
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? <DownArrow /> : <UpArrow />) : <DefaultArrow />}
                    </span>
                  )
                }
              </th>
            ))}
            <th />
          </tr>
        ))}
        </thead>
        <tbody>
        {rows.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
        )}
        </tbody>
      </table>
      {
        totalPages > 1 && <ReactPaginate
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          pageCount={totalPages}
          onPageChange={(page) =>
            setCurrentPage(page.selected + 1)
          }
        />
      }
    </>
  )
}

export default FormSubmissionsTab;
